import React from 'react';
import styled from 'styled-components';
import { ModalContext } from '../context/modal';
import * as CONSTANTS from '../constants';
import Router from 'next/router';
import { logEvent } from '../utils/analytics';

const PageTitle = styled.h1`
    text-align: center;
    margin-top: 30px;
    padding: 0 30px;
    font-size: 24px;
    font-weight: 200;
    display: table;
    margin: 30px auto 0 auto;
    ${props => (props.darkMode === true) ? `
    color: #fff;
    ` : ''}

    & .query {
        font-weight: 200;
        border-bottom: 2px dashed ${CONSTANTS.mediumGray};
        ${props => (props.darkMode === true) ? `
        color: #fff;
        ` : ''}
    }

    & .breadcrumb {
        ${props => (props.darkMode === true) ? `
        color: #fff;
        &:hover {
            color: #ccc;
        }
      ` : ''}
    }

    & .remove {
        color: ${CONSTANTS.mediumGray};
        position: absolute;
        top: -17px;
        right: -16px;
    }

    & .withSearch, & .noFilterResults {
        position: relative;
        font-weight: 200;
        ${props => (props.darkMode === true) ? `
        color: #fff;
        ` : ''}
    }

    & .withSearch {
        cursor: pointer;
    }

    & a {
        font-size: 13px;
        font-weight: 200;
        position: relative;
        top: -4px;
        text-decoration: underline;
    }
`;

/*
        ${props => (props.allowDismiss === false) ? `
        cursor: initial;
        ` : ''}
*/


export default class Title extends React.PureComponent {
    constructor(props) {
        super(props);

        this.removeSearch = this.removeSearch.bind(this);
    }

    removeSearch(e) {
        e.preventDefault();

        const breadCrumbElementClicked = e.target.classList.contains('breadcrumb');
        const searchCloseClicked = e.target.classList.contains('withSearch') || e.target.classList.contains('query');

        if(breadCrumbElementClicked) {
            logEvent('details page | breadcrumb', 'click');
        } else if(searchCloseClicked) {
            logEvent('gallery | clear search', 'click');
        }

        if((this.props.showBreadcrumb && breadCrumbElementClicked) || this.props.allowDismiss || searchCloseClicked) {
            this.context.updateValue('currentSearch', 'resetToOriginalEntries');

            const href = '/';
        
            const as = href;
            Router.push(href, as, { shallow: true });
        }

        return;
    }

    render() {
        const title = this.props.showBreadcrumb ? (`<a class="breadcrumb" aria-label="Gallery" href="/">Gallery →</a> ${this.props.title}`) : this.props.title;

        return (
            <div>
                <PageTitle
                    darkMode={this.context.darkMode}
                    allowDismiss={this.props.allowDismiss}
                    dangerouslySetInnerHTML={{__html: title}}
                    onClick={(e) => this.removeSearch(e)}
                />
            </div>
        );
    }
}

Title.contextType = ModalContext;
